import {
  queryTask,
  queryTeamMember,
  transactTask,
  pickTask,
  getTaskDetail,
  taskType,
  taskSource,
  completeTask
} from './../../../api/task'
import { i18n } from '@/common/utils/i18n'
import {isEmpty} from 'lodash-es'
import {fetchDetail} from '@/api'
import CacheMachine from '@/common/utils/CacheMachine'

const _TRUE_ = true
const _FALSE_ = false
let shopDetail = new CacheMachine({})
let currentShopDetail = {}

export default {
  namespaced: true,
  state: {
    list: {
      list: [],
      total: 0
    },
    types: [],
    sources: [],
    query: {
      status: 20,
      pageNo: 1,
      pageSize: 10,
      source: null,
      type: null
    },
    taskFilter: {
      status: []
    },
    typeFilterNum: '',
    selectStatus: i18n.gettext('待办理'),
    selectRank: i18n.gettext('优先级'),
    shopDetail,
    currentShopDetail
  },
  mutations: {
    updateList (state, data) {
      state.list = {
        list: state.list.list.concat(data.list),
        total: data.total
      }
    },
    updateTaskFilter (state, data) {
      state.taskFilter = data
    },
    clearTaskList (state) {
      state.list = {
        list: [],
        total: 0
      }
    },
    updateType (state, data) {
      const keys = Object.keys(data)
      state.types = keys.map((key) => {
        return {
          text: data[key],
          value: parseInt(key, 10)
        }
      })
    },
    updateSource (state, data) {
      const keys = Object.keys(data)
      state.sources = keys.map((key) => {
        return {
          text: data[key],
          value: parseInt(key, 10)
        }
      })
    },
    updateQuery (state, query) {
      state.query = query
    },
    updateTypeFilterNum (state, data) {
      state.typeFilterNum = data
    },
    updateSelectStatus (state, data) {
      state.selectStatus = data
    },
    updateSelectRank (state, data) {
      state.selectRank = data
    },
    updateDetail (state, payload) {
      state.shopDetail = Object.assign(state.shopDetail, payload)
    },
    updateCurrentDetail (state, payload) {
      state.currentShopDetail = Object.values(payload)[0]
    },
    clearCurrentShopDetail (state) {
      state.currentShopDetail = {}
    },
    clearShopDetailCache (state, payload) {
      let obj = {}
      let {
        shopId
      } = payload
      obj[shopId] = {}
      state.shopDetail = Object.assign(state.shopDetail, obj)
    }
  },
  actions: {
    async doQueryTaskList (store, payload) {
      const userInfo = store.rootState.login.userInfo
      try {
        const {
          query
        } = payload
        const ret = await queryTask({
          ...query,
          timezone: userInfo.timezone
        })
        store.commit('updateList', ret.data)
      } catch (e) {
        console.log(e)
      }
    },
    async doCompleteTask (store, payload) {
      const userInfo = store.rootState.login.userInfo
      try {
        const {
          query,
          cb
        } = payload
        const ret = await completeTask({
          ...query,
          timezone: userInfo.timezone
        })
        cb(ret.data)
      } catch (e) {
        console.log(e)
      }
    },
    async doGetTaskDetail (store, payload) {
      const userInfo = store.rootState.login.userInfo
      try {
        const {
          query,
          cb
        } = payload
        const ret = await getTaskDetail({
          ...query,
          timezone: userInfo.timezone
        })
        cb(ret.data)
      } catch (e) {
        console.log(e)
      }
    },
    async doGetTeamMember (store, payload) {
      const userInfo = store.rootState.login.userInfo
      try {
        const {
          query,
          cb
        } = payload
        const ret = await queryTeamMember({
          ...query,
          timezone: userInfo.timezone
        })
        cb(ret.data.list)
      } catch (e) {
        console.log(e)
      }
    },
    async doGetSource (store) {
      const userInfo = store.rootState.login.userInfo
      try {
        const ret = await taskSource({timezone: userInfo.timezone})
        store.commit('updateSource', ret.data)
      } catch (e) {
        console.log(e)
      }
    },
    async doGetType (store, source) {
      const userInfo = store.rootState.login.userInfo
      try {
        const ret = await taskType({
          source,
          timezone: userInfo.timezone
        })
        store.commit('updateType', ret.data)
      } catch (e) {
        console.log(e)
      }
    },
    async doChangeTask (store, data) {
      const userInfo = store.rootState.login.userInfo
      const {
        query = {},
        cb
      } = data
      try {
        await transactTask({
          ...query,
          timezone: userInfo.timezone
        })
        cb(_TRUE_)
      } catch (e) {
        cb(_FALSE_)
        console.log(e)
      }
    },
    async doPickTask (store, data) {
      const userInfo = store.rootState.login.userInfo
      const {
        query = {},
        cb
      } = data
      try {
        await pickTask({
          taskId: query,
          timezone: userInfo.timezone
        })
        cb(_TRUE_)
      } catch (e) {
        cb(_FALSE_)
        console.log(e)
      }
    },
    // 以后不管是商机还是商家，都调用detail，后续会进行迭代优化
    getDetail ({ commit, state }, params) {
      let {
        shopId,
        cb
      } = params
      let detail = state.shopDetail[shopId]
      if (!isEmpty(detail)) {
        commit('updateCurrentDetail', { [shopId]: detail })
        return detail
      }
      return fetchDetail({
        shopId
      }).then(res => {
        let detail = { [shopId]: res.data }
        commit('updateDetail', detail)
        commit('updateCurrentDetail', detail)
        return res.data
      }).catch((err) => {
        cb(err)
        console.log(err)
      })
    }
  }
}
